import type { ReactNode } from 'react'
import { useContractGameStore } from '../../store/useContractGameStore'
import { PokerSidebar } from './PokerSidebar'
import { CodeRainCanvas } from './CodeRainCanvas'
import { FluidCanvas } from './FluidCanvas'

type PokerLayoutProps = {
  sidebarHeader: ReactNode
  children: ReactNode
  showCodeRain?: boolean
  showBossFluid?: boolean
  animationChips?: number
  animationMult?: number
  isAnimating?: boolean
  animationHandType?: string
  animationHandLevel?: number
  animationPhase?: string
}

export function PokerLayout({
  sidebarHeader,
  children,
  showCodeRain = false,
  showBossFluid = false,
  animationChips,
  animationMult,
  isAnimating,
  animationHandType,
  animationHandLevel,
  animationPhase,
}: PokerLayoutProps) {
  const clausePool = useContractGameStore((s) => s.clausePool)

  return (
    <div
      className="flex flex-col md:flex-row h-full overflow-hidden pl-2 md:pl-6 gap-1 md:gap-3"
      style={{
        background: showBossFluid
          ? 'linear-gradient(160deg, rgba(80,20,20,0.85) 0%, rgba(50,12,12,0.82) 40%, rgba(65,18,18,0.85) 100%)'
          : 'linear-gradient(160deg, rgba(27,58,45,0.85) 0%, rgba(15,42,30,0.82) 40%, rgba(22,46,36,0.85) 100%)',
      }}
    >
      <PokerSidebar
        header={sidebarHeader}
        animationChips={animationChips}
        animationMult={animationMult}
        isAnimating={isAnimating}
        animationHandType={animationHandType}
        animationHandLevel={animationHandLevel}
        animationPhase={animationPhase}
      />

      <div className="flex-1 flex flex-col overflow-hidden relative">
        {showBossFluid ? <FluidCanvas /> : showCodeRain ? <CodeRainCanvas clauses={clausePool} /> : null}

        {/* Felt texture overlay */}
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.03]"
          style={{
            backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
            backgroundSize: '20px 20px',
            zIndex: 1,
          }}
        />

        {children}
      </div>
    </div>
  )
}
